module.exports = __webpack_public_path__ + "img/spinner-logo.137bfb9a.png";